import { render } from "./ThanksView.vue?vue&type=template&id=3ae7533a&scoped=true"
import script from "./ThanksView.vue?vue&type=script&lang=js"
export * from "./ThanksView.vue?vue&type=script&lang=js"

import "./ThanksView.vue?vue&type=style&index=0&id=3ae7533a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kobayashi.y\\develop\\thxily_fastapi\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae7533a"]])

export default __exports__